var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-label",attrs:{"for":_vm.forId},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default"),_vm._v(" "),(_vm.isRequired)?_c('div',{staticClass:"asterisk"},[_vm._v("\n    *\n  ")]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48584d1b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../raypro_ui/src/components/ui/inputs/InputLabel.vue
// module id = null
// module chunks = 